import NewAppIFrame from 'components/NewAppIFrameViewer'
import React from 'react'

const UserProfileV2 = () => {
  return (
    <NewAppIFrame 
      iFramePagePath="profile"
      title="User Profile"
      />
  )
}

export default UserProfileV2